/**
 * Protected route composition (APP-001 §7, APP-002 §30).
 *
 * Wraps the dashboard layout with:
 *   <AuthBoundary>              — Clerk initialized + signed in
 *     <AccountBootstrap>        — backend account resolved (sync-pending handled)
 *       <AccountGate>           — onboarding vs. dashboard routing (APP-002 §30)
 *         <DashboardLayout>     — shell + identity context (app or focus
 *                                 variant; chosen by AccountGate)
 *           <Outlet/>           — dashboard page
 *
 * `AccountGate` (APP-002) routes a signed-in, ready account whose onboarding
 * is incomplete to `/onboarding`, and redirects completed onboarding traffic
 * on `/onboarding` back to `/dashboard`. The gate reads the local completion
 * marker ONLY after AccountBootstrap resolved `ready` — the marker is never
 * authoritative for account readiness (APP-002 §6).
 */
import { Outlet } from 'react-router-dom';
import { AuthBoundary } from './AuthBoundary';
import { AccountBootstrap } from './AccountBootstrap';
import { AccountGate } from './AccountGate';

export function ProtectedRoute() {
  return (
    <AuthBoundary>
      <AccountBootstrap>
        {(identity) => (
          // AccountGate renders the shell (full app nav, or the focus shell
          // while onboarding is incomplete) around the matched route.
          <AccountGate identity={identity}>
            <Outlet />
          </AccountGate>
        )}
      </AccountBootstrap>
    </AuthBoundary>
  );
}
